import StoreX from '../../redux/oldStore';

const REASONS: Record<string, { title: string; body: string; icon: string; showSignIn?: boolean }> = {
  notFound: {
    title: 'File Not Found',
    body: 'Sorry, the file you are looking for cannot be found.',
    icon: 'fal fa-file-search',
  },
  signIn: {
    title: 'Sign-in Required',
    body: 'You must sign in to view this file.',
    icon: 'fal fa-lock',
    showSignIn: true,
  },
  unknownProject: {
    title: 'Invalid Request',
    body: "We can't find the file or the project you are trying to reference.",
    icon: 'fal fa-map-marker-slash',
  },
  unknownFile: {
    title: 'Invalid Request',
    body: "We can't find the file you are trying to reference.",
    icon: 'fal fa-file-search',
  },
};

/**
 * File access errors (replaces File/fileError.cshtml). Uses the shared error page layout.
 */
const FileErrorPage = () => {
  const reason = (StoreX.GetQueryStringValue('reason') || 'notFound').toLowerCase();
  const info = REASONS[reason] || REASONS.notFound;

  return (
    <div className="main-body-page grow" data-testid="file-error-page">
      <div className="text-center" style={{ padding: '40px 20px' }}>
        <div className="alert alert-danger" style={{ display: 'inline-block', textAlign: 'left', maxWidth: 560 }}>
          <h2>
            <i className={info.icon} /> {info.title}
          </h2>
          <p data-testid="file-error-message">{info.body}</p>
          {info.showSignIn && (
            <p>
              <a href="/?login=true" className="btn btn-info">
                <i className="fal fa-sign-in" /> Sign-In
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileErrorPage;
